import { useEffect, useState } from "react";
import { fcmClient } from "./index";
import { usePushNotifications } from "./pushContext";

/** Long enough that the offer does not collide with the splash screen or the shell's loading backdrop. */
const SHOW_DELAY_MS = 2500;

const DEVICE_NOUN = { ANDROID: "phone", IOS: "phone", WEB: "browser" };

/**
 * One-time offer to turn push on, shown while the choice is still open. Accepting is the user gesture
 * browsers require for the permission prompt, and on native it puts an explanation in front of the
 * system dialog. "Not now" is remembered per device; Settings keeps the switch.
 */
const PushInviteBanner = () => {
  const { status, busy, enable, dismissInvite } = usePushNotifications();
  const [elapsed, setElapsed] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setElapsed(true), SHOW_DELAY_MS);
    return () => clearTimeout(timer);
  }, []);

  if (!status.invite || !elapsed) return null;

  const noun = DEVICE_NOUN[fcmClient.platform] ?? "device";

  return (
    <div
      role="dialog"
      aria-label="Turn on push notifications"
      className="fixed z-30 top-20 inset-x-3 sm:inset-x-auto sm:right-6 sm:w-96 rounded-2xl border border-app-border bg-app-surface shadow-lg p-4"
    >
      <h3 className="text-sm font-semibold text-app-text m-0">Turn on push notifications?</h3>
      <p className="text-sm text-app-text-secondary m-0 mt-1">
        Get alerts on this {noun} as soon as they happen, even when Kothar is closed.
      </p>
      <div className="flex justify-end gap-2 mt-3">
        <button
          type="button"
          onClick={dismissInvite}
          disabled={busy}
          className="rounded-lg border border-app-border bg-transparent px-3 py-1.5 text-sm font-medium text-app-text-secondary cursor-pointer"
        >
          Not now
        </button>
        <button
          type="button"
          onClick={enable}
          disabled={busy}
          className="rounded-lg border-0 bg-teal-700 px-3 py-1.5 text-sm font-semibold text-white cursor-pointer"
        >
          Turn on
        </button>
      </div>
    </div>
  );
};

export default PushInviteBanner;
